import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SheerIdFinePrint } from 'Components/SheerIdFinePrint';
import { useIntervalTimer } from 'Hooks/useIntervalTimer';
import { SHEER_PAGE_TYPES, SHEER_PAGE_TITLES, SHEER_PAGE_STATUS } from 'Utils/SheerIdHelpers';
import BangoBackButton from 'Components/BangoBackButton/BangoBackButton';
import { getUserSheerInfo } from 'State/Integrations/IntegrationsActions';
import CenterFrameLayout from 'Layouts/CenterFrameLayout';
import './SheerIdReviewPage.css';

export const SheerIdReviewPage = ({ setPage, setTitle, layoutProps }) => {
  const dispatch = useDispatch();
  useIntervalTimer(async () => {
    try {
      const response = await dispatch(getUserSheerInfo());
      if (SHEER_PAGE_STATUS[response.currentStep] !== SHEER_PAGE_TYPES.REVIEW) {
        setPage(SHEER_PAGE_STATUS[response.currentStep], response);
      }
    } catch (error) {
      setPage(SHEER_PAGE_TYPES.ERROR, error);
    }
    // 10,000 === 10 Seconds
  }, 10000);

  useEffect(() => {
    setTitle(SHEER_PAGE_TITLES[SHEER_PAGE_TYPES.REVIEW]);
  }, [setTitle]);
  return (
    <CenterFrameLayout {...layoutProps}>
      <div className="sheerIdReviewPage">
        <BangoBackButton />
        <h2 className="reviewTitle">Reviewing</h2>
        <div className="reviewInfo">
          <div className="reviewText">
            Turnaround time for your language is typically a few minutes, and in rare times of high volume may take up
            to 20 minutes.
          </div>
          <div className="reviewText">Wait here or let us notify you of the outcome.</div>
          <div className="reviewText">You will be contacted via email.</div>
        </div>
        <SheerIdFinePrint isReview />
      </div>
    </CenterFrameLayout>
  );
};
